(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pulse-card-seller-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-pulse-card-sellers-open]');
    if (openButton) {
      const dialogId = openButton.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-pulse-card-sellers-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    const dialog = event.target.closest('[data-pulse-card-sellers-dialog]');
    if (dialog && event.target === dialog) dialog.close();
  });
  } catch(e) { console.error(e); }
})();

})();
